import microuniversoApi from "app/api/microuniversoApi";
import { useAppSelector } from "app/redux/hooks";
import { RespostaCadastroCliente } from "app/types/cliente/RespostaCadastroCliente";
import { IClassificacao } from "app/types/IClassificacao";
import { ICliente } from "app/types/ICliente";
import { IEndereco } from "app/types/IEndereco";
import { Parametro } from "app/types/Parametro";
import { Permissao } from "app/types/Permissao";
import { tratamentoErroPadrao } from "app/use-cases";
import { obterPermissao } from "app/use-cases/obterPermissao";
import { cadastroCliente } from "app/use-cases/orcamento/cliente/cadastroCliente";
import { obterParametros } from "app/use-cases/parametro/obterParametros";
import { Dict } from "app/utils/Dict";
import clsx from "clsx";
import { FormikErrors } from "formik";
import globalMU from "globalMU";
import * as R from "ramda";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { v4 as uuidv4 } from 'uuid';
import { removerClienteOrcamento } from "../../use-cases/orcamento/cliente/removerClienteOrcamento";
import { Abas } from "../abas/Abas";
import { Breadcrumb2Container } from "../breadcrumb2/Breadcrumb2Container";
import { CampanhasDeDescontosDisponiveisContainer } from "../cupom-desconto/CampanhasDeDescontosDisponiveisContainer";
import { MenuConsultasClienteContainer } from "../menu-consultas-cliente/MenuConsultasClienteContainer";
import { removerComponenteReact, renderizarComponentReact } from "../renderizarOuRemoverComponentReact";
import { AbaClassificacaoContainer } from "./aba-classificacao/AbaClassificacaoContainer";
import { AbaEnderecosContainer } from "./aba-enderecos/AbaEnderecosClienteContainer";
import { NovoEnderecoClienteContainer } from "./aba-enderecos/novo-endereco/NovoEnderecoClienteContainer";
import { DadosBasicosClienteContainer } from "./dados-basicos-pesquisa-clientes/DadosBasicosClienteContainer";
import { DadosClienteContainer } from "./dados-cliente/DadosClienteContainer";
import { DadosGuiaClienteContract, FormularioDadosGuiaCliente } from "./dados-cliente/DadosCliente";
import { PesquisarClienteContainer } from "./PesquisarClienteContainer";
import { salvarNovoClienteOrcamento } from "app/use-cases/orcamento/cliente/salvarNovoClienteOrcamento";
import { salvarClienteOrcamento } from "app/use-cases/orcamento/cliente/salvarClienteOrcamento";
import { TooltipMU } from "../tooltip/TooltipMU";
import { MicrouniversoApi } from "app/api/classes/MicrouniversoApi";
import store from "app/redux/store/store";
import { gravarTelasAlteradasSalvaAction } from "app/redux/telaOrcamentoAlteradaNaoSalvaSlice";

declare var window: any;

const estilosBotoes = require("../../estilos/botoes.module.scss").default;

type NomesAbas = "Dados Básicos" | "Classificação" | "Endereços"  | "Dados Cliente";

export type AbasPesquisaClienteContainerProps = {
  regiaoRenderizada: string
  abaSelecionada?: "Dados Básicos" | "Classificação" | "Endereços"  | "Dados Cliente";
  foraOrcamento?: boolean
  codigoClienteSelecionado?: number
  onVoltar?: () => void,
  passos?: Dict<string, () => void>
};

export const AbasPesquisaClienteContainer = (props: AbasPesquisaClienteContainerProps) => {

  const [processando, setProcessando] = useState(true);
  const orcamento = props.foraOrcamento ? {} : useAppSelector((store) => store.orcamento); // 431546 - 430877
  const identificadorOrcamento = orcamento.IdentificadorOrcamento;
  const [somenteLeitura, setSomenteLeitura] = useState<boolean>(false)
  const [somenteLeituraEndereco, setSomenteLeituraEndereco] = useState<boolean>(false) // 462631
  const [permiteEditarCpfCnpj, setPermiteEditarCpfCnpj] = useState<boolean>(false)
  const [abaSelecionada, setAbaSelecionada] = useState<NomesAbas>(props.abaSelecionada ?? "Dados Básicos");
  const [permiteEditarEnderecoComercial, setPermiteEditarEnderecoComercial] = useState<boolean>(false) // 465680
  const [abas, setAbas] = useState<{ nome: string }[]>([])
  const [parametros, setParametros] = useState<Parametro[]>([])
  const [permissoes, setPermissoes] = useState<Permissao[]>([])
  const [executandoGravacao, setExecutandoGravacao] = useState<boolean>(false) // 440006

  const [dadosCliente, setDadosCliente] = useState<RespostaCadastroCliente>();
  const [enderecos, setEnderecos] = useState<IEndereco[]>();

  const [dadosGuiaCliente, setDadosGuiaCliente] = useState<FormularioDadosGuiaCliente>();
  const [dadosGuiaClienteOriginal, setDadosGuiaClienteOriginal] = useState<DadosGuiaClienteContract>();

  const [validarDadosBasicos, setValidarDadosBasicos] = useState(false);
  const [formulariovalidado, setFormularioValidado] = useState(false);
  const [errosFormulario, setErrosFormulario] = useState<FormikErrors<ICliente>>();

  const [classificacoesSelecionadas, setClassificacoesSelecionadas] = useState<IClassificacao[]>([]);
  const [classificacoesDisponiveis, setClassificacoesDisponiveis] = useState<IClassificacao[]>([]);

  const [enderecosSelecionados, setEnderecosSelecionados] = useState<IEndereco[]>([]);
  const [enderecosTemporarios, setEnderecosTemporarios] = useState<IEndereco[]>()
  const [exibeIncluirEndereco, setExibeIncluirEndereco] = useState(false);
  const [enderecoAEditar, setEnderecoAEditar] = useState<IEndereco>();
  const [carregando, setCarregando] = useState<boolean>(true);
  const [mostrarBotaoIncluirEndereco, setMostrarBotaoIncluirEndereco] = useState(null) // 465680
  const [permitirAlterarDadosBasicos, setPermitirAlterarDadosBasicos] = useState(false)
  const passosInterno = useRef<Dict<string, () => void>>(props.passos ? new Dict(Object.assign({}, props.passos.map)) : new Dict())

  const isMounted = useRef<boolean>(true);
  useEffect(() => () => { isMounted.current = false; }, []);
/*
  const atualizarPermissoes = async () => {
    setPermissoes([
      {
        Acao: "ORCAMENTO_ALTERAR_NOME_RAZAOSOCIAL_CLIENTE",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_ALTERAR_NOME_RAZAOSOCIAL_CLIENTE" })
      },
      {
        Acao: "ALTERAR",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ALTERAR" })
      },
      {
        Acao: "INCLUIR",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "INCLUIR" })
      },
      {
        Acao: "ALTERAR_CLASSIFICACAO",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ALTERAR_CLASSIFICACAO" })
      },
      {
        Acao: "ORCAMENTO_ALTERAR_ENDERECO_CLIENTE",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_ALTERAR_ENDERECO_CLIENTE" })
      },
      {
        Acao: "ORCAMENTO_INCLUIR_ENDERECO_CLIENTE",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_INCLUIR_ENDERECO_CLIENTE" })
      },
      {
        Acao: "ORCAMENTO_EXCLUIR_ENDERECO_CLIENTE",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_EXCLUIR_ENDERECO_CLIENTE" })
      },
      {
        Acao: "ORCAMENTO_ALTERAR_ENDERECO_CLIENTE",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_ALTERAR_ENDERECO_CLIENTE" })
      },
  
      {
        Acao: "CONSULTAR_CLASSIFICACAO",
        Permitido: await obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "CONSULTAR_CLASSIFICACAO" })
      },
  
    ])
  }
  
  
  const atualizarParametros = async () => {
    setParametros(
      await obterParametros({
        nomes: [
          "VISUALIZA_VENDEDOR_RELACIONADO_CONSCLIENTE",
          "UTILIZAR_BAIRROS_PRE_CADASTRADOS",
          "TRABALHA_CUPOM_DESCONTO",
          "BAIRRO_NUMERO_OPCIONAL_CADASTRO_CLIENTE",
        ],
      })
    );
  };
  */


  const atualizarPermissoes = useCallback(async () => {
  const permissoesAtualizadas = await Promise.all([
    obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_ALTERAR_NOME_RAZAOSOCIAL_CLIENTE" }),
    obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ALTERAR" }),
    obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "INCLUIR" }),
    obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ALTERAR_CLASSIFICACAO" }),
    obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_ALTERAR_ENDERECO_CLIENTE" }),
    obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_INCLUIR_ENDERECO_CLIENTE" }),
    obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "ORCAMENTO_EXCLUIR_ENDERECO_CLIENTE" }),
    obterPermissao({ funcionalidade: "ORCAMENTO_CLIENTE", acao: "CONSULTAR_CLASSIFICACAO" }),
  ]);

  setPermissoes([
    { Acao: "ORCAMENTO_ALTERAR_NOME_RAZAOSOCIAL_CLIENTE", Permitido: permissoesAtualizadas[0] },
    { Acao: "ALTERAR", Permitido: permissoesAtualizadas[1] },
    { Acao: "INCLUIR", Permitido: permissoesAtualizadas[2] },
    { Acao: "ALTERAR_CLASSIFICACAO", Permitido: permissoesAtualizadas[3] },
    { Acao: "ORCAMENTO_ALTERAR_ENDERECO_CLIENTE", Permitido: permissoesAtualizadas[4] },
    { Acao: "ORCAMENTO_INCLUIR_ENDERECO_CLIENTE", Permitido: permissoesAtualizadas[5] },
    { Acao: "ORCAMENTO_EXCLUIR_ENDERECO_CLIENTE", Permitido: permissoesAtualizadas[6] },
    { Acao: "CONSULTAR_CLASSIFICACAO", Permitido: permissoesAtualizadas[7] },
  ])

  setMostrarBotaoIncluirEndereco(permissoesAtualizadas[5]) // 465680

  }, []);

  const atualizarParametros = useCallback(async () => {
  const parametrosAtualizados = await obterParametros({
    nomes: [
      "VISUALIZA_VENDEDOR_RELACIONADO_CONSCLIENTE",
      "UTILIZAR_BAIRROS_PRE_CADASTRADOS",
      "TRABALHA_CUPOM_DESCONTO",
      "BAIRRO_NUMERO_OPCIONAL_CADASTRO_CLIENTE",
      "COMPLETAR_DADOS_CLIENTE_ORCAMENTO",
    ],
  });
  setParametros(parametrosAtualizados);
  }, []);

  const valorParametro = (nome: string) => parametros.find(p => p.Nome == nome)?.Valor

  const valorPermissaoPorAcao = (nome: string) => permissoes.find(p => p.Acao == nome)?.Permitido

  // useCallback + functional setState — elimina enderecosSelecionados das deps (#22)
  const onToggleEnderecoSelecionado = useCallback((endereco: IEndereco) => {
    setEnderecosSelecionados(prev =>
      prev.includes(endereco)
        ? R.filter((e: IEndereco) => e !== endereco, prev)
        : prev.concat(endereco)
    );
  }, []);

  const onSalvarClassificacoesSelecionadas = (classificacoesSelecionadas: IClassificacao[]) => {
    setClassificacoesSelecionadas(classificacoesSelecionadas);
  };

  const onSalvarClassificacoesDisponiveis = (classificacoesDisponiveis: IClassificacao[]) => {
    setClassificacoesDisponiveis(classificacoesDisponiveis);
  };

  const cadastrarCliente = async (forcarAtualizar: boolean = false, oidCliente: number = 0) => {
    try {
      globalMU.blockUI();
      globalMU.blockScreen()

      const codigoCliente = oidCliente > 7
        ? oidCliente
        : props.foraOrcamento
          ? props.codigoClienteSelecionado
          : orcamento?.Cliente?.Codigo <= 7
            ? null
                                            : orcamento?.Cliente?.Codigo;

      const dadosPesquisados = await cadastroCliente(codigoCliente, forcarAtualizar, props.foraOrcamento)
      if (!isMounted.current) return;

      setDadosCliente(dadosPesquisados);
      await setEnderecos([]) // 440006
      await setEnderecosSelecionados([])
      await setEnderecosTemporarios([])

      setEnderecos(dadosPesquisados?.Cliente?.Enderecos ?? []);

      setClassificacoesSelecionadas(dadosPesquisados?.Classificacoes?.filter(c => dadosPesquisados.Cliente?.Classificacoes?.some(cc => cc == c.Codigo)))
      setClassificacoesDisponiveis(dadosPesquisados?.Classificacoes?.filter(c => !dadosPesquisados.Cliente?.Classificacoes?.some(cc => cc == c.Codigo)))

      setPermiteEditarCpfCnpj(!orcamento?.SomenteLeitura && !dadosPesquisados?.Cliente?.SomenteLeitura
        && (dadosPesquisados?.Cliente?.Codigo <= 7 || (dadosPesquisados?.Cliente?.Codigo > 7 && dadosPesquisados?.Cliente?.CpfCnpj == "")))

      const permiteAlterar = valorPermissaoPorAcao("ALTERAR") //430731
      const permiteIncluir = valorPermissaoPorAcao("INCLUIR") //430731

      const somenteLeituraLocal = dadosPesquisados?.Cliente?.SomenteLeitura || orcamento?.SomenteLeitura
                ||  (orcamento?.Cliente?.Codigo > 7 && !permiteAlterar) || (orcamento?.Cliente?.Codigo <= 7 && !permiteIncluir) //430731
      // 430731 - setSomenteLeitura(dadosPesquisados?.Cliente?.SomenteLeitura || orcamento?.SomenteLeitura)
      setSomenteLeitura(somenteLeituraLocal) // 430731
      setSomenteLeituraEndereco(dadosPesquisados?.Cliente?.SomenteLeitura || orcamento?.SomenteLeitura) // 430731 ->462631

      let permiteEditarEnderecoComercial = true // 465680
      const enderecoComercial = dadosPesquisados?.Cliente?.Enderecos?.find(e => e.Classificacoes.includes(1068)) // 465680-- 1068-> comercial
      if  (enderecoComercial && !enderecoComercial.PermitirEditarEnderecoPessoaFisica && (dadosCliente?.Cliente?.TipoPessoa == "F" || dadosCliente?.Cliente?.TipoPessoa == "Fisica" || dadosCliente?.Cliente?.TipoPessoa == "Física")) // 441453
        {
          permiteEditarEnderecoComercial = false
        }
        else if (enderecoComercial && !enderecoComercial.PermitirEditarEnderecoPessoaJuridica && !(dadosCliente?.Cliente?.TipoPessoa == "F" || dadosCliente?.Cliente?.TipoPessoa == "Fisica" || dadosCliente?.Cliente?.TipoPessoa == "Física")) {
          permiteEditarEnderecoComercial = false
        }
      setPermiteEditarEnderecoComercial(permiteEditarEnderecoComercial && valorPermissaoPorAcao("ORCAMENTO_ALTERAR_ENDERECO_CLIENTE")) // 465680

      if (dadosPesquisados?.Cliente != undefined) {
        window.AsideDireita.show("cliente-pesquisa");

        renderizarComponentReact(
          <MenuConsultasClienteContainer
            onSelecionadoMenu={() => {
              $("[container]").hide();
            }}
            codigoCliente={dadosPesquisados?.Cliente?.Codigo}
            possuiAcompanhamento={dadosPesquisados?.Cliente?.PossuiAcompanhamento}
            possuiAtendimento={dadosPesquisados?.Cliente?.PossuiAtendimentoNaoLido}
            possuiCredito={dadosPesquisados?.Cliente?.PossuiCreditos}
            possuiCashback={dadosPesquisados.Cliente?.PossuiCashback}
            //462631 ---somenteLeitura={somenteLeituraLocal} // 430731
            somenteLeitura={// 430731-> 462631
              dadosPesquisados?.Cliente?.SomenteLeitura || orcamento?.SomenteLeitura
                    ||  (orcamento?.Cliente?.Codigo > 7 && !permiteAlterar) || (orcamento?.Cliente?.Codigo <= 7 && !permiteIncluir)
            } // 430731-> 462631
            onVoltar={() =>
            (
              removerComponenteReact("conteudo-pagina"),
              renderizarComponentReact(
                <AbasPesquisaClienteContainer {...props} />,
                props.regiaoRenderizada,
                true
              ))}
            passos={passosInterno.current}
            pesquisarClientesController={this}
          />,
          "cliente-pesquisa-react",
          true
        );
      }



    } catch (e) {
      if (isMounted.current) tratamentoErroPadrao(e);
    } finally {
      if (isMounted.current) setCarregando(false)
      globalMU.unblockUI()
      globalMU.unblockScreen()
    }
  };

  const ativaEditarEndereco = (ativa: boolean, endereco: IEndereco) => {
    if (endereco && endereco?.Codigo > 7) {

      if (!endereco.PermitirEditarEnderecoPessoaFisica && (dadosCliente?.Cliente?.TipoPessoa == "F" || dadosCliente?.Cliente?.TipoPessoa == "Fisica" || dadosCliente?.Cliente?.TipoPessoa == "Física")) // 441453
      {
        globalMU.showErrorMessage("Não é permitido alterar o endereço cobrança de um cliente pessoa física!");
        return false
      }
      else if (!endereco.PermitirEditarEnderecoPessoaJuridica && !(dadosCliente?.Cliente?.TipoPessoa == "F" || dadosCliente?.Cliente?.TipoPessoa == "Fisica" || dadosCliente?.Cliente?.TipoPessoa == "Física")) {
        globalMU.showErrorMessage("Não é permitido alterar o endereço de um cliente pessoa jurídica!");
        return false
      }
    }

    setEnderecoAEditar(endereco);
    setExibeIncluirEndereco(ativa);
  };

  const editarEndereco = (enderecoAEditar: IEndereco) => {
    let copiaDeEnderecosTemporarios = enderecosTemporarios?.map(i => i.Codigo == enderecoAEditar.Codigo ? enderecoAEditar : i)

    setEnderecosTemporarios(copiaDeEnderecosTemporarios);

    const copiaEnderecos = enderecos?.map(i => i.Codigo == enderecoAEditar.Codigo ? enderecoAEditar : i)

    const enderececoComComercial = enderecoAEditar.DescricaoClassificacoes.includes("Comercial");

    if (enderececoComComercial) {
      setDadosCliente({
        ...dadosCliente,
        Cliente: {
          ...dadosCliente.Cliente,
          Endereco: enderecoAEditar.Logradouro,
          Cep: enderecoAEditar.Cep,
          NumeroEndereco: enderecoAEditar.Numero,
          CodigoEstado: enderecoAEditar.CodigoEstado,
          Bairro: enderecoAEditar.Bairro,
          CodigoCidade: enderecoAEditar.CodigoCidade,
          NomeCidade: enderecoAEditar.NomeCidade,
          ComplementoEndereco: enderecoAEditar.Complemento,
          SiglaUf: enderecoAEditar.SiglaUf,
          Referencia: enderecoAEditar.Referencia,
          Enderecos: copiaEnderecos
        }
      })
    }
    setEnderecos(copiaEnderecos)
  }

  const adicionarEndereco = (endereco: IEndereco) => {
    let copiaDeEnderecosTemporarios = Object.assign([], enderecosTemporarios)
    copiaDeEnderecosTemporarios.push({ ...endereco, Codigo: uuidv4() })
    setEnderecosTemporarios(copiaDeEnderecosTemporarios)
    const enderececoComComercial = endereco.DescricaoClassificacoes.includes("Comercial");

    if (enderececoComComercial) {
      setDadosCliente({
        ...dadosCliente,
        Cliente: {
          ...dadosCliente.Cliente,
          Endereco: endereco.Logradouro,
          Cep: endereco.Cep,
          NumeroEndereco: endereco.Numero,
          CodigoEstado: endereco.CodigoEstado,
          Bairro: endereco.Bairro,
          CodigoCidade: endereco.CodigoCidade,
          NomeCidade: endereco.NomeCidade,
          ComplementoEndereco: endereco.Complemento,
          SiglaUf: endereco.SiglaUf,
          Referencia: endereco.Referencia,
        }
      })
    }
  }

  const excluirEnderecoTemporario = useCallback((selecionados: IEndereco[]) => {
    setEnderecosTemporarios(prev => prev.filter(e => !selecionados.some(i => i.Codigo == e.Codigo)));
  }, []);

  const salvarTodosDados = async () => {

    let gravouSemErros = false
    let oidClienteGravado = 7
    try {

      globalMU.blockUI()
      setExecutandoGravacao(true) // 440006
      // 490808 - não trocar de aba ao salvar (permanece na aba atual); só redireciona p/ "Endereços" em caso de erro de endereço abaixo

      let copiaDeEnderecosTemporarios = enderecos?.concat(enderecosTemporarios?.map(endereco => endereco.Codigo < 0 ? { ...endereco, Codigo: 0 } : endereco) ?? [])
      let copiaDeDadosCliente = {
        ...dadosCliente.Cliente,
        Enderecos: copiaDeEnderecosTemporarios,
        Classificacoes: classificacoesSelecionadas?.map(c => c.Codigo) ?? [],
        DadosGuiaCliente: montarDadosGuiaCliente()
      }

      if (copiaDeDadosCliente?.Email && copiaDeDadosCliente?.Email?.length > 0 && !globalMU.validateMultipleEmails(copiaDeDadosCliente.Email)) {
        //globalMU.showErrorMessage("E-mail NF-e inválido.");
        return false;
      }
      if (copiaDeDadosCliente.AtualizarEmailPixAPrazo && copiaDeDadosCliente?.EmailPixAPrazo && copiaDeDadosCliente?.EmailPixAPrazo?.length > 0
        && !globalMU.validateMultipleEmails(copiaDeDadosCliente.EmailPixAPrazo)) {

        return false;
      }


      const resposta = props.foraOrcamento
        ? await microuniversoApi.Cliente.salvar(copiaDeDadosCliente)
        : copiaDeDadosCliente.Codigo == 0
          ? await salvarNovoClienteOrcamento(identificadorOrcamento, copiaDeDadosCliente)
                                    : await salvarClienteOrcamento(identificadorOrcamento, copiaDeDadosCliente)
      if (!isMounted.current) return;

      oidClienteGravado = props.codigoClienteSelecionado == undefined || props.codigoClienteSelecionado <= 7  // 447905
              ? resposta.Codigo  // 447905
              : props.codigoClienteSelecionado // 447905


      var mensagemerro = (resposta as any)?.Error?.Error ?? "";

      var temErro = (resposta as any)?.HasErrors ?? false;
      if (!temErro) // (!("HasErrors" in resposta)) {
      {

        if (!props.foraOrcamento && orcamento) {

          await microuniversoApi.Orcamento.alterarEmailPixPrazoNoOrcamento(orcamento.IdentificadorOrcamento, copiaDeDadosCliente.EmailPixAPrazo) // 414608 pixPrazo
          if (!isMounted.current) return;

          if (!copiaDeDadosCliente.AtualizarEmailPixAPrazo && copiaDeDadosCliente.EmailPixAPrazo != copiaDeDadosCliente.EmailPixAPrazoOriginal) // 414608 pixPrazo
          {
            globalMU.showInfoMessage("O e-mail do PIX não será atualizado.");
          }

        }

        global.showSuccessMessage("Registro atualizado com sucesso!");
        setEnderecos(resposta.Enderecos);
        setEnderecosTemporarios([])
        gravouSemErros = true // 453510
        store.dispatch(gravarTelasAlteradasSalvaAction("clientePesquisa_dadosCliente")) // 490808 - limpar dirty flag da aba Dados Cliente após salvar


      }
      if (mensagemerro.includes("Obrigatório existir endereço classificado como")) {
        setAbaSelecionada("Endereços")
        gravouSemErros = false // 453510
      }


    } catch (err) {
      gravouSemErros = false
      if (isMounted.current) tratamentoErroPadrao(err)
    } finally {

      if (isMounted.current) {
        setFormularioValidado(true)  // 440006
        setExecutandoGravacao(false) // 440006
      }
      globalMU.unblockUI()
    }

    if (gravouSemErros) {
      try {
        setExecutandoGravacao(true) // 440006
        globalMU.blockUI()

        await cadastrarCliente(true, oidClienteGravado) // 440006

      } catch (err) {
        if (isMounted.current) tratamentoErroPadrao(err)
      } finally {
        globalMU.unblockUI()
        if (isMounted.current) setExecutandoGravacao(false) // 440006
      }

    }
  }

  const manterDadosTemporariosDadosBasicos = (dadosTemporariosAtualizado: ICliente) => {

    setDadosCliente({ ...dadosCliente, Cliente: dadosTemporariosAtualizado });
  }

  const manterDadosTemporariosGuiaCliente = (dadosTemporariosAtualizado: FormularioDadosGuiaCliente) => {
    setDadosGuiaCliente(dadosTemporariosAtualizado);
  }

  const RTIPO_TELEFONE = 1071;
  const RTIPO_FAX = 1072;
  const RTIPO_EMAIL = 1073;
  const RTIPO_CELULAR = 1075;
  const RTIPO_SITE = 1076;

  const montarComunicacoes = (): Array<{ Rtipo: number, Oid: number, Valor: string, Alterado: boolean }> => {
    if (!dadosGuiaCliente) return []

    const original = dadosGuiaClienteOriginal?.Comunicacoes ?? []
    const telefonesOriginais = original.filter(c => c.Rtipo == RTIPO_TELEFONE)
    const emailsOriginais = original.filter(c => c.Rtipo == RTIPO_EMAIL)
    const faxOriginal = original.find(c => c.Rtipo == RTIPO_FAX)
    const celularOriginal = original.find(c => c.Rtipo == RTIPO_CELULAR)
    const siteOriginal = original.find(c => c.Rtipo == RTIPO_SITE)

    const item = (rtipo: number, original: { Oid: number, Valor: string }, valor: string) => {
      const v = typeof valor === "string" ? valor : "" // 490808 - coagir p/ string; ?? não trata false/boolean e vazava Valor:false -> .F. no VFP
      return {
        Rtipo: rtipo,
        Oid: original?.Oid ?? 0,
        Valor: v,
        Alterado: v != (original?.Valor ?? "")
      }
    }

    return [
      item(RTIPO_TELEFONE, telefonesOriginais[0], dadosGuiaCliente.Tel1),
      item(RTIPO_TELEFONE, telefonesOriginais[1], dadosGuiaCliente.Tel2),
      item(RTIPO_FAX, faxOriginal, dadosGuiaCliente.Fax),
      item(RTIPO_EMAIL, emailsOriginais[0], dadosGuiaCliente.Mail1),
      item(RTIPO_EMAIL, emailsOriginais[1], dadosGuiaCliente.Mail2),
      item(RTIPO_EMAIL, emailsOriginais[2], dadosGuiaCliente.Mail3),
      item(RTIPO_SITE, siteOriginal, dadosGuiaCliente.Site),
      item(RTIPO_CELULAR, celularOriginal, dadosGuiaCliente.Celular),
    ].filter(i => i.Alterado || i.Oid > 7)
  }

  const RDEFINICAO_BANCO = 16983;
  const RDEFINICAO_AGENCIA = 16984;
  const RDEFINICAO_CONTA = 16985;

  const montarDadosAdicionais = () => {
    if (!dadosGuiaCliente) return []

    const original = dadosGuiaClienteOriginal?.DadosAdicionais ?? []
    const bancoOriginal = original.find(d => d.RDefinicao == RDEFINICAO_BANCO)
    const agenciaOriginal = original.find(d => d.RDefinicao == RDEFINICAO_AGENCIA)
    const contaOriginal = original.find(d => d.RDefinicao == RDEFINICAO_CONTA)
    const creaOriginal = original.find(d => d.RDefinicao != RDEFINICAO_BANCO && d.RDefinicao != RDEFINICAO_AGENCIA && d.RDefinicao != RDEFINICAO_CONTA)

    const item = (rDefinicao: number, original: { Oid: number, Valor: string }, valor: string) => {
      if (!rDefinicao) return null
      const v = typeof valor === "string" ? valor : "" // 490808 - coagir p/ string (ver montarComunicacoes)
      return {
        RDefinicao: rDefinicao,
        Oid: original?.Oid ?? 0,
        Valor: v,
        Alterado: v != (original?.Valor ?? "")
      }
    }

    return [
      item(RDEFINICAO_BANCO, bancoOriginal, dadosGuiaCliente.Banco),
      item(RDEFINICAO_AGENCIA, agenciaOriginal, dadosGuiaCliente.Agencia),
      item(RDEFINICAO_CONTA, contaOriginal, dadosGuiaCliente.Conta),
      item(creaOriginal?.RDefinicao, creaOriginal, dadosGuiaCliente.Crea),
    ].filter(i => i != null && (i.Alterado || i.Oid > 7))
  }

  const montarContato = () => {
    if (!dadosGuiaCliente) return undefined

    const original = dadosGuiaClienteOriginal?.Contato
    const nome = typeof dadosGuiaCliente.ContatoNome === "string" ? dadosGuiaCliente.ContatoNome : "" // 490808 - coagir p/ string
    const cargo = typeof dadosGuiaCliente.ContatoCargo === "string" ? dadosGuiaCliente.ContatoCargo : "" // 490808
    const alterado = nome != (original?.Nome ?? "") || cargo != (original?.Cargo ?? "")

    return {
      Oid: original?.Oid ?? 0,
      Nome: nome,
      Cargo: cargo,
      Alterado: alterado
    }
  }

  const montarDadosGuiaCliente = (): DadosGuiaClienteContract => dadosGuiaCliente ? ({
    Comunicacoes: montarComunicacoes(),
    DadosAdicionais: montarDadosAdicionais(),
    Contato: montarContato()
  }) : undefined

  const onRenderizarCupomDesconto = () => {
    renderizarComponentReact(<CampanhasDeDescontosDisponiveisContainer onVoltar={() => renderizarComponentReact(<PesquisarClienteContainer {...props} />, "conteudo-pagina", true)} />, "conteudo-pagina", true)
  }

  const onLimpar = async () => {
    if (!confirmarSaidaComAlteracoesNaoSalvas('Dados foram alterados e não foram aplicados!\n\nAo limpar, o cliente será desvinculado do orçamento e as alterações serão perdidas.\n\nDeseja continuar?')) return
    await removerClienteOrcamento(orcamento.IdentificadorOrcamento);
    if (!isMounted.current) return;
    setDadosCliente({})
    setEnderecos([])
    setEnderecosSelecionados([]) // 440006
    setEnderecosTemporarios([])
    removerComponenteReact("conteudo-pagina");
    window.AsideDireita.show("valores-orcamento");


    renderizarComponentReact(
      <PesquisarClienteContainer regiaoRenderizada={props.regiaoRenderizada} />,
      props.regiaoRenderizada,
      true
    );
  }

  const onAlterarEnderecoComercial = (enderecoDadosBasicos: IEndereco) => {

    const enderecoAba = enderecosTemporarios?.length > 0 ? enderecos?.concat(enderecosTemporarios) : enderecos;

    const enderecoComClassificacao = enderecoAba?.find(x => x.DescricaoClassificacoes.includes("Comercial"));
    const enderecoComClassificacaoTemporario = enderecosTemporarios?.find(x => x.DescricaoClassificacoes.includes("Comercial"));
    const enderecoComClassificacaoPrincipal = enderecos?.find(x => x.DescricaoClassificacoes.includes("Comercial"));

    if (enderecoAba || enderecoAba === undefined) {

      const enderecoComClassificacaoModificado = {
        ...enderecoComClassificacao,
        Logradouro: enderecoDadosBasicos.Logradouro,
        Cep: enderecoDadosBasicos.Cep,
        Numero: enderecoDadosBasicos.Numero,
        CodigoEstado: enderecoDadosBasicos.CodigoEstado,
        Bairro: enderecoDadosBasicos.Bairro,
        CodigoCidade: enderecoDadosBasicos.CodigoCidade,
        NomeCidade: enderecoDadosBasicos.NomeCidade,
        Complemento: enderecoDadosBasicos.Complemento,
        SiglaUf: enderecoDadosBasicos.SiglaUf,
        Referencia: enderecoDadosBasicos.Referencia
      };

      if (enderecoComClassificacaoModificado.Classificacoes == null || enderecoComClassificacaoModificado == undefined  || enderecoComClassificacaoModificado.Classificacoes.length == 0) {
        enderecoComClassificacaoModificado.Classificacoes = [1068] // ENDERECO_COMERCIAL
        enderecoComClassificacaoModificado.DescricaoClassificacoes = "Comercial"
      }

      if (enderecoComClassificacaoTemporario || enderecoComClassificacaoModificado !== undefined) {
        const indexTemporario = enderecosTemporarios?.findIndex(x => x.Codigo == enderecoComClassificacao.Codigo);
        const enderecomodificado = enderecosTemporarios.map((endereco, idx) => idx === indexTemporario ? enderecoComClassificacaoModificado : endereco)

        if (enderecomodificado === undefined || enderecomodificado.length == 0) {
          setEnderecosTemporarios(enderecosTemporarios.concat(enderecoComClassificacaoModificado)) // 453510
          setEnderecos(enderecosTemporarios)
        } else {
          setEnderecosTemporarios(enderecomodificado) // 440006, 440148 duplicacao endereco
        }
      }
      /* comentado ficha 453510
      if (enderecoComClassificacaoPrincipal) {
        const indexPrincipal = enderecos?.findIndex(x => x.Codigo == enderecoComClassificacao.Codigo);
        const enderecomodificado = enderecos.map((endereco, idx) => idx === indexPrincipal ? enderecoComClassificacaoModificado : endereco)
        setEnderecos(enderecomodificado)
      }
      */
    }
  };


  const permiteAbaDadosCliente = () => // 490808
    valorParametro("COMPLETAR_DADOS_CLIENTE_ORCAMENTO") === "S" &&
    ["Venda", "Outras Saídas"].includes(orcamento?.TipoOrcamentoDescricao) &&
    orcamento?.Cliente?.Codigo > 7

  const atualizarAbas = () => {
    let permiteClassificacao = valorPermissaoPorAcao("CONSULTAR_CLASSIFICACAO")
    const abasPermitidas = [
      { nome: "Dados Básicos" },
      { nome: permiteClassificacao === undefined || permiteClassificacao ? "Classificação" : undefined },
      { nome: "Endereços" },
     // 493933 { nome: permiteAbaDadosCliente() ? "Dados Cliente" : undefined } // 490808
    ].filter(aba => aba.nome != undefined)
    setAbas(abasPermitidas)
    // 490808 - preserva a aba atual se ainda existir; senão cai na primeira (Dados Básicos)
    setAbaSelecionada(prev =>
      abasPermitidas.some(aba => aba.nome === prev)
        ? prev
        : (abasPermitidas[0]?.nome as NomesAbas ?? "Dados Básicos"))
  }

  const confirmarSaidaComAlteracoesNaoSalvas = (mensagem: string): boolean => {
    if (Object.keys(store.getState().telaOrcamentoAlteradaNaoSalva).length === 0) return true
    if (!confirm(mensagem)) return false
    store.dispatch(gravarTelasAlteradasSalvaAction(""))
    return true
  }

  const onVoltar = () => {
    if (!confirmarSaidaComAlteracoesNaoSalvas('Dados foram alterados e não foram aplicados!\n\nDeseja descartar alteração?')) return
    props.onVoltar()
  }

  const onPassoSelecionado = (passo: string) => {
    passosInterno.current.get(passo)()
  }

  useEffect(() => {
    globalMU.blockScreen()
    passosInterno.current.set("Cadastro Cliente", () => (
      removerComponenteReact("conteudo-pagina"),
      renderizarComponentReact(<AbasPesquisaClienteContainer regiaoRenderizada={props.regiaoRenderizada} />, props.regiaoRenderizada, true))
    )

    const fetchData = async () => {
      await Promise.all(
        [
          atualizarParametros(),
          atualizarPermissoes()
        ])
    }

    fetchData();


    //cadastrarCliente();

  }, []);

  useEffect(() => {
    if (processando && parametros != null && parametros.length > 0 && permissoes != null && permissoes.length > 0 && dadosCliente == null) {
      cadastrarCliente();
    }
  }, [parametros, permissoes, dadosCliente]);

useEffect(() => {
    if (processando && parametros != null && parametros.length > 0 && permissoes != null && permissoes.length > 0 && dadosCliente != null && !carregando && dadosCliente != null && !carregando) {
      

      let oidClienteEditar = props.codigoClienteSelecionado ?? 0
      if (oidClienteEditar <= 7 && !props.foraOrcamento && orcamento != undefined && orcamento?.Cliente?.Codigo > 7)
        oidClienteEditar = orcamento?.Cliente?.Codigo

      let permitirDadosBasicos = !somenteLeitura
      if (permitirDadosBasicos && oidClienteEditar > 7 && !valorPermissaoPorAcao("ALTERAR"))
        permitirDadosBasicos = false
      if (permitirDadosBasicos && oidClienteEditar <= 7 && !valorPermissaoPorAcao("INCLUIR"))
        permitirDadosBasicos = false

      
      setPermitirAlterarDadosBasicos(permitirDadosBasicos)
      setProcessando(false)
    }
  }, [parametros, permissoes, dadosCliente, carregando]);

useEffect(() => {
    if (permissoes?.length > 0) {
      atualizarAbas()
    }
  }, [permissoes, parametros, orcamento?.Cliente?.Codigo, orcamento?.TipoOrcamentoDescricao]) // 490808 - recalcular abas quando cliente é associado (Codigo passa a > 7)

return (
    <>


      {!exibeIncluirEndereco && (
        <>
          <Breadcrumb2Container
            passos={passosInterno.current.keysToList()}
            id="AbasPesquisaClienteContainer"
            exibirBotaoLimpar={!props.foraOrcamento && !orcamento.SomenteLeitura}
            exibirBotaoVoltar={props.foraOrcamento}
            onBotaoLimparClicado={onLimpar}
            onBotaoVoltarClicado={onVoltar}
            onPassoSelecionado={onPassoSelecionado}
            processando={processando}
          />

        <div className="_mt-2 _border-b _border-solid _border-[#ddd] _shadow-[0_6px_rgb(0_0_0/3%)]"
          id="AbasPesquisaClienteContainer_divAbas"
        >
            <Abas
              abas={abas}
              id="AbasPesquisaClientesContainer"
              nomeAbaSelecionada={abaSelecionada}
              onAbaSelecionada={(nome) => setAbaSelecionada(nome as NomesAbas)}
            />
          </div>


          {abaSelecionada == "Dados Básicos" && !processando && (
            <DadosBasicosClienteContainer
              foraOrcamento={props.foraOrcamento} // 414608
              tipoOrcamento={orcamento.TipoOrcamento} // 414608
              IdentificadorOrcamento={identificadorOrcamento} //414608
              oidFilial={orcamento?.OidFilialOrcamento ?? undefined} // 414608 pixPrazo
              somenteLeitura={somenteLeitura} // 431546 - 430877  {orcamento.SomenteLeitura}
              permiteEditarCpfCnpj={permiteEditarCpfCnpj}
              formularioValidado={formulariovalidado}
              onValidarFormulario={setValidarDadosBasicos}
              onErrorValidacao={setErrosFormulario}
              onAlterarEnderecoComercial={onAlterarEnderecoComercial}
              permiteEditarEnderecoComercial={permiteEditarEnderecoComercial} // 465680
              dadosCliente={dadosCliente}
              permiteAlterarNomeRazaoSocial={!somenteLeitura && (orcamento?.Cliente?.Codigo <= 7 || valorPermissaoPorAcao("ORCAMENTO_ALTERAR_NOME_RAZAOSOCIAL_CLIENTE"))}
            permitirAlterarDadosBasicos={permitirAlterarDadosBasicos}
              usuarioPermitidoAlterarVendedorRelacionado={somenteLeitura && !props.foraOrcamento && valorParametro("VISUALIZA_VENDEDOR_RELACIONADO_CONSCLIENTE") === "N"}
              utilizarBairrosPreCadastrados={valorParametro("UTILIZAR_BAIRROS_PRE_CADASTRADOS") == "S"}
              manterDadosTemporariosCliente={manterDadosTemporariosDadosBasicos}
              // 493933 ocultarCelularEContato={permiteAbaDadosCliente()} // 490808
            />
          )}
{/* 493933
          {abaSelecionada == "Dados Cliente" && !processando && (
            <DadosClienteContainer
              oidCliente={dadosCliente?.Cliente?.Codigo}
              identificadorOrcamento={identificadorOrcamento}
              somenteLeitura={somenteLeitura}
              permitirAlterarDadosBasicos={permitirAlterarDadosBasicos}
              manterDadosTemporarios={manterDadosTemporariosGuiaCliente}
              onDadosGuiaClienteOriginalCarregado={setDadosGuiaClienteOriginal}
            />
          )}
*/}
          {abaSelecionada == "Classificação" && !processando && (
            <AbaClassificacaoContainer
              somenteLeitura={somenteLeitura} // 431546 - 430877 {orcamento.SomenteLeitura}
              classificacoesDisponiveis={classificacoesDisponiveis}
              classificacoesSelecionadas={classificacoesSelecionadas}
              onSalvarClassificacoesSelecionadas={onSalvarClassificacoesSelecionadas}
              onSalvarClassificacoesDisponiveis={onSalvarClassificacoesDisponiveis}
            />
          )}

          {abaSelecionada == "Endereços" && !processando && mostrarBotaoIncluirEndereco != null &&  (
            <AbaEnderecosContainer
              somenteLeitura={somenteLeituraEndereco} // 465680- 431546 - 430877 {orcamento.SomenteLeitura}
              tipoPessoa={dadosCliente?.Cliente?.TipoPessoa} // 441453
              habilitarExcluirEndereco={!somenteLeituraEndereco && orcamento?.Cliente?.Codigo <= 7 && valorPermissaoPorAcao("INCLUIR") && enderecosSelecionados.length > 0}
              permitirExcluirEndereco={!somenteLeituraEndereco && valorPermissaoPorAcao("ORCAMENTO_EXCLUIR_ENDERECO_CLIENTE") && orcamento?.Cliente?.Codigo <= 7}
              permitirEditarEndereco={!somenteLeituraEndereco && valorPermissaoPorAcao("ORCAMENTO_ALTERAR_ENDERECO_CLIENTE")}
            permitirIncluirEndereco={!somenteLeituraEndereco && mostrarBotaoIncluirEndereco} // 465680- valorPermissaoPorAcao("ORCAMENTO_INCLUIR_ENDERECO_CLIENTE")}
              enderecosSelecionados={enderecosSelecionados}
              onToggleEnderecoSelecionado={onToggleEnderecoSelecionado}
              enderecos={enderecosTemporarios?.length > 0 ? enderecos?.concat(enderecosTemporarios) : enderecos}
              ativarEditarEndereco={ativaEditarEndereco}
              excluirEnderecosTemporarios={excluirEnderecoTemporario} />
          )}

          {carregando && <div>Carregando dados do cliente. Aguarde...</div>}
        </>
      )}

      {exibeIncluirEndereco &&  !processando && (
        <NovoEnderecoClienteContainer
          utilizarBairrosPreCadastrados={valorParametro("UTILIZAR_BAIRROS_PRE_CADASTRADOS") === "S"}
          numeroEBairroObrigatorio={valorParametro("BAIRRO_NUMERO_OPCIONAL_CADASTRO_CLIENTE") !== "S"}
          clienteNaoCadastrado={false}
          editarEndereco={editarEndereco}
          adicionarEndereco={adicionarEndereco}
          endereco={enderecoAEditar}
          cpfCnpj={dadosCliente?.Cliente?.CpfCnpj}
          ativaEditarEndereco={ativaEditarEndereco}
        />
      )}

      <div className="_my-4">

        {(!somenteLeitura || !somenteLeituraEndereco) && !exibeIncluirEndereco && (valorPermissaoPorAcao("ALTERAR_CLASSIFICACAO") || valorPermissaoPorAcao("ORCAMENTO_ALTERAR_ENDERECO_CLIENTE") ||
          valorPermissaoPorAcao("ORCAMENTO_INCLUIR_ENDERECO_CLIENTE") || valorPermissaoPorAcao("ORCAMENTO_EXCLUIR_ENDERECO_CLIENTE") || permitirAlterarDadosBasicos) &&
          <>
            <TooltipMU
              //enterDelay={1000}
              title={
                <>
                  <span className="_ml-7 _text-[10px]">Só será necessário clicar em "<b>Salvar</b>" se você alterou algum dado do cliente</span>
                </>
              }
            >
              <span>
                <button
                  className={clsx('no-global-button', estilosBotoes.botaoPrimario)}
                  //title="Só será necessário clicar em Salvar se você alterou algum dado do cliente"
                  id="AbasPesquisaClienteContainer_BotaoSalvar"
                  disabled={executandoGravacao}
                  onClick={() => {
                    validarDadosBasicos ? salvarTodosDados() : globalMU.showErrorMessage(errosFormulario)
                  }
                  }
                >
                  {executandoGravacao ? "Aguarde..." : "Salvar"}
                </button>
              </span>
            </TooltipMU>
          {dadosCliente?.Cliente?.Codigo > 7 &&
            <span className="_ml-7 _text-[10px]">Só será necessário clicar em "<b>Salvar</b>" se você alterou algum dado do cliente</span>
            }
          </>
        }

        {abaSelecionada == "Dados Básicos" && valorParametro("TRABALHA_CUPOM_DESCONTO") == "S" && dadosCliente?.OrcamentoVenda &&
          <button className={`_flex _mt-2 no-global-button ${estilosBotoes.botaoPrimario}`}
            id="AbasPesquisaClienteContainer_BotaoCupomDeDesconto"
            disabled={!dadosCliente?.existeCupomDescontoParaCliente || executandoGravacao}
            onClick={onRenderizarCupomDesconto}>
            Cupons de Desconto
          </button>
        }

      </div>
      {<section style={{ marginBottom: "100px" }} />}
    </>
);
};
